"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Canvas = void 0;
class Canvas {
    // #region Constructors (1)
    constructor(_id, _originalDefinition, _canvasElement) {
        this._id = _id;
        this._originalDefinition = _originalDefinition;
        this._canvasElement = _canvasElement;
        if (this._originalDefinition &&
            this._originalDefinition instanceof HTMLCanvasElement)
            this._originalDefinition = (this._originalDefinition.cloneNode(true));
        if (!_canvasElement) {
            this._canvasElement = document.createElement("canvas");
            this._canvasElement.id = this._id;
        }
        else {
            this._canvasElement = _canvasElement;
        }
        this._canvasElement.style.touchAction = "none";
    }
    // #endregion Constructors (1)
    // #region Public Accessors (2)
    get canvasElement() {
        return this._canvasElement;
    }
    get id() {
        return this._id;
    }
    // #endregion Public Accessors (2)
    // #region Public Methods (1)
    reset() {
        var _a;
        const parent = (_a = this._canvasElement) === null || _a === void 0 ? void 0 : _a.parentElement;
        parent === null || parent === void 0 ? void 0 : parent.removeChild(this._canvasElement);
        if (this._originalDefinition instanceof HTMLCanvasElement) {
            parent === null || parent === void 0 ? void 0 : parent.appendChild(this._canvasElement);
        }
    }
}
exports.Canvas = Canvas;
//# sourceMappingURL=Canvas.js.map